import axios from 'axios';
import Vue from 'vue'

export default {

    addClaimWithQrc(codclt, blnum ,ts, subject, message, serviceId, serviceTypeId) {
        const claimRequest ={id:null, subject: subject, message : message , blNumber:null, customerId: null, serviceId:serviceId,serviceTypeId:serviceTypeId}
        return axios.post('/api/qrc/add/claim',claimRequest, {params:{codclt:codclt, blnum:blnum, ts:ts }})
        .then(response => {
            if (response && response.data) {
                //Vue.prototype.$snotify.success('Votre Reclamation est ajoutée avec succès')
                return response.data
            }
        })
        .catch(error => {


            Vue.prototype.$snotify.error(error);})

        
    },
    
}